import { render, staticRenderFns } from "./tagPrint.vue?vue&type=template&id=47b93620"
import script from "./tagPrint.vue?vue&type=script&lang=js"
export * from "./tagPrint.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports